import * as t from 'io-ts';

import {makeApiType} from './apiTypes';

/*
 * Runtime type.
 */

export const RPatchTeamPreferencesTeammateError = t.type({
  teammateId: t.number,
  errorCode: t.string,
});

const RPatchTeamPreferencesDirty = t.readonly(
  t.type({
    failedTeammateIdsWithError: t.union([t.readonlyArray(RPatchTeamPreferencesTeammateError), t.undefined]),
  }),
);

/*
 * Type.
 */

export interface PatchTeamPreferencesTeammateError
  extends t.TypeOf<typeof RPatchTeamPreferencesTeammateError> {}
export interface PatchTeamPreferencesModel extends t.TypeOf<typeof RPatchTeamPreferencesDirty> {}
export const RPatchTeamPreferences = t.clean<PatchTeamPreferencesModel>(RPatchTeamPreferencesDirty as any);

/*
 * IO methods.
 */

function parseFailedTeammateIdWithError(src: any): PatchTeamPreferencesTeammateError {
  return {
    teammateId: src.teammate_id,
    errorCode: src.error_code,
  };
}

export function parsePatchTeamPreferences(src: any): PatchTeamPreferencesModel {
  if (!src.failed_teammate_ids_with_error || !src.failed_teammate_ids_with_error.length) {
    return {failedTeammateIdsWithError: undefined};
  }

  return {
    failedTeammateIdsWithError: src.failed_teammate_ids_with_error.map(parseFailedTeammateIdWithError),
  };
}

/*
 * API type.
 */

export const ApiPatchTeamPreferences = makeApiType(
  'patchTeamPreferences',
  RPatchTeamPreferences,
  parsePatchTeamPreferences,
);
